import InlineBasket from 'components/InlineBasket/InlineBasket';
import { withInlineBasketProps } from 'viewModel/inlineBasket/withInlineBasketProps';

export default withInlineBasketProps(InlineBasket);
